import React from 'react'
import { Link } from 'react-router-dom'
import BackButton from '../../ChildComponent/BackButton'
import COLORS from '../../resources/colors/COLORS'

const WA = '#25D366'
const WA_DARK = '#128C7E'

// Created By Cursor — shared chrome for Compose / Queue / Inbox pages
export default function CommWhatsAppPageShell({
  title,
  breadcrumb,
  activeNav,
  children,
  headerExtra = null,
}) {
  return (
    <div className="content">
      <div className="content-header d-flex justify-content-between align-items-center">
        <div className="leftside-content-header d-flex align-items-center">
          <i
            className="fa fa-home"
            aria-hidden="true"
            style={{
              fontSize: 18,
              color: COLORS.primary_color,
              cursor: 'pointer',
              marginRight: 10,
            }}
            onClick={() => {
              window.location.href = '/AdminMain'
            }}
          />
          <ul className="breadcrumbs mb-0">
            <li>Communication</li>
            <li>WhatsApp</li>
            {breadcrumb ? <li>{breadcrumb}</li> : null}
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div
        className="bg_page_white_rounded box_shadow"
        style={{ '--mMargin': '50px', padding: 0, overflow: 'hidden' }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 10,
            padding: '12px 16px',
            background: `linear-gradient(120deg, ${WA_DARK} 0%, ${WA} 100%)`,
            color: '#fff',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
            <span
              style={{
                width: 34,
                height: 34,
                borderRadius: 9,
                background: 'rgba(255,255,255,0.2)',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <i className="fa fa-whatsapp" style={{ fontSize: 18 }} />
            </span>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 800, fontSize: 16, lineHeight: 1.2 }}>
                {title}
              </div>
              <div style={{ fontSize: 11, opacity: 0.9, fontWeight: 600 }}>
                School ERP WhatsApp
              </div>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 8,
            }}
          >
            {headerExtra}
            <NavChip
              to="/AdminMain/CommunicationPanel"
              label="Compose"
              active={activeNav === 'compose'}
            />
            <NavChip
              to="/AdminMain/WhatsAppQueue"
              label="Queue"
              active={activeNav === 'queue'}
            />
            <NavChip
              to="/AdminMain/WhatsAppInbox"
              label="Inbox"
              active={activeNav === 'inbox'}
            />
          </div>
        </div>

        <div style={{ padding: '14px 16px 16px' }}>{children}</div>
      </div>
    </div>
  )
}

// Created By Cursor
function NavChip({ to, label, active, onClick }) {
  return (
    <Link
      to={to}
      onClick={onClick}
      style={{
        color: '#fff',
        fontWeight: 700,
        fontSize: 12,
        textDecoration: 'none',
        background: active ? 'rgba(0,0,0,0.28)' : 'rgba(255,255,255,0.16)',
        border: active
          ? '1px solid rgba(255,255,255,0.55)'
          : '1px solid rgba(255,255,255,0.28)',
        borderRadius: 8,
        padding: '6px 10px',
      }}
    >
      {label}
    </Link>
  )
}
